import Head from 'next/head'
import Image from 'next/image'

import bobPic from '../public/images/bob update.jpeg'
import Layout from '../components/Layout'

export default function Home(): JSX.Element {
  return (
    <Layout>
      <Head>
        <title>Robert Karasov - Minneapolis Mohel | Home</title>
      </Head>
      <h1 className="mb-6 font-serif text-4xl text-ink sm:text-3xl">
        About Robert Karasov
      </h1>
      <section>
        <div className="float-right ml-6 mb-4 w-1/2 max-w-xs overflow-hidden rounded-xl border border-hairline shadow-card sm:ml-4">
          <Image alt="Bob Karasov headshot" src={bobPic} />
        </div>
        <div className="space-y-4 leading-relaxed text-ink">
          <p>
            I am a general pediatrician who has been practicing at Park Nicollet
            since 1985 and a Mohel since 1985. I have performed well over 1000
            brises in addition to many thousands of non-ritual circumcisions in
            my medical practice. I have performed brises for the Orthodox,
            Conservative, Reform, Reconstructionist and unaffiliated communities
            and have co-officiated with Clergy from all denominations.
          </p>
          <p>
            I was trained by Rabbi Barry Cytron, a Conservative Rabbi, and also
            studied the laws of ritual circumcision (Hilchot Milah) for 6 months
            with Rabbi Jerome Herzog, an Orthodox Rabbi. I have been flown coast
            to coast to perform brises from North Carolina to California. I have
            taught many classes on the laws of Brit Milah and have helped train
            several Mohels. I have created several Brit Milah ceremonies
            including the ones used by many local synagogues.
          </p>
          <p>
            I am an Observant Jew and a member of Darchei Noam Congregation (a
            modern Orthodox synagogue). I have served as a lay Cantor on the
            High Holidays for Congregations in Minneapolis and Kansas City and I
            bring my love of music and singing to the Brit Milah ceremony.
          </p>
        </div>
      </section>
    </Layout>
  )
}
